import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';
import { IBodyCreateProject, IProjectData } from '../common/models/project.interface';
import { BehaviorSubject, Observable } from 'rxjs';

const API_URL = environment.API_URL + '/project/';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(private httpService: HttpService) {}
  private projectChange$ = new BehaviorSubject<IProjectData | null>(
    this.getProjectFromLocalStorage() || null
  );

  setCurrentProject(project: IProjectData): void {
    localStorage.setItem('selectedProjectFromHeader', JSON.stringify(project));
    this.projectChange$.next(project);
  }

  getProjectFromLocalStorage(): IProjectData | null {
    const project = localStorage.getItem('selectedProjectFromHeader');
    if (project) {
      return JSON.parse(project) as IProjectData;
    }
    return null;
  }
  
  getProjectFromHeaderObservable(): Observable<IProjectData | null> {
    return this.projectChange$.asObservable();
  }
  
  getProjectsByClientId(id: string) {
    return this.httpService.get(API_URL + 'client/' + id);
  }

  getProjectById(id: string) {
    return this.httpService.get(API_URL + id);
  }

  createProject(body: IBodyCreateProject) {
    return this.httpService.post(API_URL, body);
  }

  deleteProject(id: string) {
    return this.httpService.delete(API_URL + id);
  }
}
